
import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileNav from './MobileNav';
import { useAuth } from '../../contexts/AuthContext';

interface LayoutProps {
  children: React.ReactNode;
  fullWidth?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, fullWidth = true }) => {
  const { user } = useAuth();

  return (
    <div className="flex h-screen w-full bg-background text-foreground overflow-hidden">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden min-w-0">
        <Header />
        <main className={`flex-1 overflow-y-auto p-4 sm:p-6 md:p-8 ${user ? 'pb-24 md:pb-8' : 'pb-8'} flex flex-col`}>
            <div className={`${fullWidth ? 'w-full max-w-[1920px] mx-auto' : 'mx-auto max-w-7xl w-full'} flex-1 flex flex-col`}>
                {children}
            </div>
        </main>
      </div>
      <MobileNav />
    </div>
  );
};

export default Layout;
